import React, { forwardRef, useImperativeHandle, useState, useRef } from "react";
import { Loader2, Check, X } from "lucide-react";

const GlobalLoadingIndicator = forwardRef((props, ref) => {
  const [state, setState] = useState("hidden"); // "hidden" | "saving" | "saved" | "failed"
  const timeoutRef = useRef(null);
  
  useImperativeHandle(ref, () => ({
    show: () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = null;
      }
      setState("saving");
    },
    hide: () => {
      // Show "Saved" briefly, then hide
      setState("saved");
      timeoutRef.current = setTimeout(() => {
        setState("hidden");
        timeoutRef.current = null;
      }, 1000);
    },
    showFailed: () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = null;
      }
      // Stay visible until next save
      setState("failed");
    },
  }));

  const isVisible = state !== "hidden";
  
  return (
    <div className={`flex items-center gap-2 transition-all duration-200 ${isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-2 pointer-events-none'}`}>
      {state === "saving" ? (
        <Loader2 className="h-4 w-4 animate-spin text-muted-foreground" />
      ) : state === "failed" ? (
        <X className="h-4 w-4 text-red-500" />
      ) : (
        <Check className="h-4 w-4 dark:text-teal-400 text-teal-500" />
      )}
      <span className={`text-xs ${state === "failed" ? "text-red-500" : "text-muted-foreground"}`}>
        {state === "saving" ? "Saving" : state === "failed" ? "Save failed" : "Saved"}
      </span>
    </div>
  );
});

GlobalLoadingIndicator.displayName = "GlobalLoadingIndicator";

export default GlobalLoadingIndicator;

